/** Where a model's own word for a level sits, low to high. Each provider says the same steps differently. */
const LEVEL_ORDER: Record<string, number> = {
  draft: 1, minimal: 2, low: 2, basic: 2, fast: 2, turbo: 2,
  medium: 3, balanced: 3, normal: 3, standard: 3,
  quality: 4, high: 4, pro: 4,
  ultra: 5, max: 6,
};

const rankOf = (key: string): number | null => {
  const word = key.trim().toLowerCase();
  if (word === 'auto') return Infinity;
  if (LEVEL_ORDER[word] !== undefined) return LEVEL_ORDER[word]!;
  const size = /^(\d+(?:\.\d+)?)(k|p)$/.exec(word);
  return size ? (size[2] === 'p' ? Number(size[1]) : Number(size[1]) * 1080 + 1) : null;
};

/**
 * A level or size menu, low to high. ai-back lists a model's values with its default first so a picker can open on it,
 * so the menu orders them itself. A list holding any other word (an ordinary count or length) stays as given.
 */
export function orderedChoices<T extends readonly [string, string]>(options: readonly T[]): readonly T[] {
  const ranks = new Map(options.map(([key]) => [key, rankOf(key)]));
  if ([...ranks.values()].some(rank => rank === null)) return options;
  return [...options].sort(([a], [b]) => ranks.get(a)! - ranks.get(b)!);
}

/** Gemini's lowest level is `minimal`, GPT Image's `low`: one word for the same step. The value sent stays the model's. */
export const levelWord = (value: string) => value.trim().toLowerCase() === 'minimal' ? 'Low' : value;
